import React, { Suspense, lazy } from "react";
import { Loader2 } from "lucide-react";

// Mapping for category components
const categoryComponents = {
  Building: lazy(() => import("./AssetCategories/Building")),
  Landscaping: lazy(() => import("./AssetCategories/Landscaping")),
  Machinery: lazy(() => import("./AssetCategories/Machinery")),
  Other: lazy(() => import("./AssetCategories/Other")),
  Room: lazy(() => import("./AssetCategories/Room")),
  // "Room QR": lazy(() => import("./AssetCategories/Room")),
};

const AssetCategoryPage = ({ category, title }) => {
  const CategoryComponent =
    categoryComponents[category] || categoryComponents.Other;

  return (
    <div className="flex flex-col h-screen bg-background">
      {/* Header */}
      <div className="border-b bg-card">
        <div className="px-6 py-4">
          <h1 className="text-2xl font-bold tracking-tight">
            {title || category} Assets
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Manage and organize {category.toLowerCase()} assets
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto">
        <div className="p-6">
          <Suspense
            fallback={
              <div className="flex flex-col items-center justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
                <p className="text-muted-foreground">Loading content...</p>
              </div>
            }
          >
            <CategoryComponent category={category} />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default AssetCategoryPage;
